import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL, entities} from '../../util/uiconstants';
import queryString from 'query-string';
import {getBodyRelatedObjectsUrl, getRelatedObjectsUrl} from '../apiUrls';
import _ from 'lodash';

export const getRelatedObjects = (engagementId, documentId, documentEntityId, entityId, entityUId) => {
	const url = getRelatedObjectsUrl(engagementId, documentId, {documentEntityId, entityId, entityUId});

	return {
		type: types.GET_RELATED_OBJECTS,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		documentEntityId,
		entityId,
		entityUId
	};
};

export const getSectionRelatedObjects = (documentId, engagementId, sectionId, includeEntityName) => {
	const url =
		Env.getBaseURL(serviceURL, engagementId) +
		`Forms/${documentId}/Sections/${sectionId}/RelatedObjects?IncludeEntityName=${includeEntityName}`;

	return {
		type: types.GET_SECTION_RELATED_OBJECTS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		sectionId: sectionId,
		includeEntityName: includeEntityName
	};
};

export const unrelateObject = (engagementId, documentId, documentRelatedObjectId, entityId, id) => {
	const url = `${getRelatedObjectsUrl(engagementId, documentId)}/${documentRelatedObjectId}`;

	return {
		type: types.DELETE_RELATED_OBJECTS,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		documentRelatedObjectId,
		entityId,
		id
	};
};

export const relateObject = (engagementId, documentId, entityId, entityUId, name) => {
	const url = getRelatedObjectsUrl(engagementId, documentId);

	return {
		type: types.CREATE_RELATED_OBJECTS,
		name,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'POST',
				data: {
					entityId,
					entityUId
				}
			}
		},
		entityId,
		entityUId
	};
};

export const relateSectionObject = (engagementId, documentId, sectionId, item) => {
	const url = getSectionRelatedObjectsUrl(engagementId, documentId, sectionId);
	let entityId = item.entityId,
		entityUId = item.id.toString(),
		parentEntityId = item.entityId === entities.Risk ? entities.Engagement : item.parentEntityId,
		parentEntityUId = item.entityId === entities.Risk ? engagementId.toString() : item.parentEntityUId.toString(),
		isTopLevel =
			item.entityId === entities.Risk || item.entityId === entities.WCGW || item.entityId === entities.ItSoApplication
				? true
				: false;

	return {
		type: types.CREATE_SECTION_RELATED_OBJECTS,
		item,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'POST',
				data: {
					entityId,
					entityUId,
					parentEntityId,
					parentEntityUId,
					isTopLevel
				}
			}
		}
	};
};

export const unrelateSectionObject = (engagementId, documentId, sectionId, formSectionRelatedObjectId, item) => {
	const url = `${getSectionRelatedObjectsUrl(engagementId, documentId, sectionId)}/${formSectionRelatedObjectId}`;

	return {
		type: types.DELETE_SECTION_RELATED_OBJECTS,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		formSectionRelatedObjectId,
		sectionId,
		item
	};
};

export const getSectionRelatedObjectsUrl = (engagementId, documentId, sectionId, queryStringParameters) => {
	queryStringParameters = _.omitBy(queryStringParameters, _.isNil);

	const searchString = !_.isEmpty(queryStringParameters) ? `?${queryString.stringify(queryStringParameters)}` : '';
	const url = `${Env.getBaseURL(
		serviceURL,
		engagementId
	)}Forms/${documentId}/Sections/${sectionId}/RelatedObjects${searchString}`;

	return url;
};

export function updateRelatedObject(data) {
	return {
		type: types.UPDATE_RELATEOBJECTS_AFTER_RESPONSE,
		response: data
	};
}

export function updateSectionRelatedObject(data) {
	return {
		type: types.UPDATE_SECTION_RELATEDOBJECTS_AFTER_RESPONSE,
		response: data
	};
}

export function addBodyRelatedObject(engagementId, documentId, bodyId, data) {
	const url = getBodyRelatedObjectsUrl(engagementId, documentId, bodyId);

	return {
		type: types.CREATE_BODY_RELATED_OBJECT,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		documentId: documentId,
		bodyId: bodyId
	};
}

export function removeBodyRelatedObject(engagementId, documentId, bodyId, bodyRelatedObjectId) {
	const url = `${getBodyRelatedObjectsUrl(engagementId, documentId, bodyId)}/${bodyRelatedObjectId}`;

	return {
		type: types.DELETE_BODY_RELATED_OBJECT,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		documentId: documentId,
		bodyId: bodyId
	};
}
